<div class="stepper-body">
    <div class="body-title">
        <span>Do you own {{address}}?</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(OwnershipOptions.Yes)
                        }" (click)="onAnswerSelected(OwnershipOptions.Yes)">
                {{OwnershipOptions.Yes}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(OwnershipOptions.No)
                        }" (click)="onAnswerSelected(OwnershipOptions.No)">
                {{OwnershipOptions.No}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary"
            (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>